import { useState } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import CustomerTypeSection from './components/CustomerTypeSection';
import SmartStoreSection from './components/SmartStoreSection';
import DifferentiatorsSection from './components/DifferentiatorsSection';
import ProcessSection from './components/ProcessSection';
import CtaSection from './components/CtaSection';
import Footer from './components/Footer';
import ContactModal from './components/ContactModal';

export default function Home() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="min-h-screen" style={{ fontFamily: '\'Noto Sans KR\', sans-serif' }}>
      <Navbar onContactClick={() => setModalOpen(true)} />
      <main>
        <HeroSection onContactClick={() => setModalOpen(true)} />
        <ServicesSection />
        <CustomerTypeSection onContactClick={() => setModalOpen(true)} />
        <SmartStoreSection />
        <DifferentiatorsSection />
        <ProcessSection />
        <CtaSection onContactClick={() => setModalOpen(true)} />
      </main>
      <Footer />
      <ContactModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  );
}
